import React from 'react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Plus, Trash2 } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../components/ui/dialog';
export const AltaRapidaDialog = ({ altaRapidaData, handleAltaRapidaAddRow, handleAltaRapidaChange, handleAltaRapidaRemoveRow, handleSaveAltaRapida, isAltaRapidaDialogOpen, saving, setIsAltaRapidaDialogOpen, unidades }) => {
  return (
      <Dialog open={isAltaRapidaDialogOpen} onOpenChange={setIsAltaRapidaDialogOpen}>
        <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Plus className="w-5 h-5 text-blue-600" />
              Alta de Unidades
            </DialogTitle>
          </DialogHeader>
          <form onSubmit={handleSaveAltaRapida} className="space-y-4">
            <p className="text-sm text-slate-500">
              Carga de unidades con información básica. Se crean sin propietario asignado y fuera de administración.
            </p>
            
            <div className="border rounded-lg overflow-hidden">
              <table className="w-full">
                <thead>
                  <tr className="bg-slate-50 border-b">
                    <th className="text-left text-xs font-semibold uppercase tracking-wider text-slate-500 py-2 px-3">Nombre *</th>
                    <th className="text-left text-xs font-semibold uppercase tracking-wider text-slate-500 py-2 px-3 w-32">Tipo</th>
                    <th className="w-10"></th>
                  </tr>
                </thead>
                <tbody>
                  {altaRapidaData.map((row, index) => (
                    <tr key={index} className="border-b last:border-b-0">
                      <td className="py-2 px-3">
                        <Input
                          value={row.nombre_unidad}
                          onChange={(e) => handleAltaRapidaChange(index, 'nombre_unidad', e.target.value)}
                          placeholder="Ej: Oficina 1A"
                          className="h-9"
                          data-testid={`alta-rapida-nombre-${index}`}
                        />
                      </td>
                      <td className="py-2 px-3">
                        <Select value={row.tipo} onValueChange={(v) => handleAltaRapidaChange(index, 'tipo', v)}>
                          <SelectTrigger className="h-9" data-testid={`alta-rapida-tipo-${index}`}>
                            <SelectValue />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="oficina">Oficina</SelectItem>
                            <SelectItem value="local">Local</SelectItem>
                            <SelectItem value="cowork">Cowork</SelectItem>
                            <SelectItem value="cochera">Cochera</SelectItem>
                          </SelectContent>
                        </Select>
                      </td>
                      <td className="py-2 px-1">
                        {altaRapidaData.length > 1 && (
                          <Button
                            type="button"
                            variant="ghost"
                            size="icon"
                            className="h-8 w-8"
                            onClick={() => handleAltaRapidaRemoveRow(index)}
                            data-testid={`alta-rapida-remove-${index}`}
                          >
                            <Trash2 className="w-4 h-4 text-red-500" />
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={handleAltaRapidaAddRow}
              className="w-full"
              data-testid="alta-rapida-add-row"
            >
              <Plus className="w-4 h-4 mr-2" />
              Agregar otra unidad
            </Button>
            
            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => setIsAltaRapidaDialogOpen(false)}>Cancelar</Button>
              <Button type="submit" disabled={saving} data-testid="alta-rapida-submit">
                {saving ? 'Creando...' : `Crear ${altaRapidaData.filter(u => u.nombre_unidad.trim()).length} Unidades`}
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
  );
};
